import type {
  DatePickerTruncationUnit,
  RelativeDatePickerValue,
} from "metabase/querying/common/types";
import * as Lib from "metabase-lib";

import { DEFAULT_OFFSETS } from "./constants";

export function setUnit(
  value: RelativeDatePickerValue,
  unit: DatePickerTruncationUnit,
): RelativeDatePickerValue {
  return { ...value, unit };
}

export function setDefaultOffset(
  value: RelativeDatePickerValue,
): RelativeDatePickerValue {
  // SP-SP-2376-include-today-default: preserve any existing options (notably
  // includeCurrent) instead of wiping to undefined, so the "include current
  // period" toggle survives a unit change.
  return {
    ...value,
    offsetValue: DEFAULT_OFFSETS[value.unit] * Math.sign(value.value),
    offsetUnit: value.unit,
    options: value.options,
  };
}

export function getIncludeCurrent(value: RelativeDatePickerValue): boolean {
  // SP-SP-2376-include-today-default: default to true so "Past N days/weeks/etc."
  // includes the current period by default — analyst users expected "Last 7 days"
  // to include today.
  return value.options?.includeCurrent ?? true;
}

export function getIncludeCurrentLabel(unit: DatePickerTruncationUnit): string {
  return Lib.describeTemporalInterval("current", unit).toLowerCase();
}

export function setIncludeCurrent(
  value: RelativeDatePickerValue,
  includeCurrent: boolean,
): RelativeDatePickerValue {
  return { ...value, options: { includeCurrent: includeCurrent } };
}
